export default {
      id: "ic-misc-download-usage",
      viewBox: "0 0 30 30",
      url: "../dist/images/" + "sprite.svg#ic-misc-download-usage",
      toString: function () {
        return this.url;
      }
    }